import { render, staticRenderFns } from "./sourcingFlow.vue?vue&type=template&id=67e7c6ab&scoped=true&"
import script from "./sourcingFlow.vue?vue&type=script&lang=js&"
export * from "./sourcingFlow.vue?vue&type=script&lang=js&"
import style0 from "./sourcingFlow.vue?vue&type=style&index=0&id=67e7c6ab&prod&lang=scss&scoped=true&"
import style1 from "./sourcingFlow.vue?vue&type=style&index=1&id=67e7c6ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e7c6ab",
  null
  
)

export default component.exports